import type { ReactNode } from "react";
import { useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

interface WizardLayoutProps {
  children?: ReactNode;
}

/** Structure and class names match app-pwa WizardLayout.vue so shared CSS applies. */
export function WizardLayout({ children }: WizardLayoutProps) {
  const location = useLocation();
  const mainRef = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const resetScrollPosition = () => {
      mainRef.current?.scrollTo({ top: 0, left: 0 });
      mainRef.current
        ?.querySelectorAll<HTMLElement>(".wizard-page__content")
        .forEach((el) => el.scrollTo({ top: 0, left: 0 }));
      window.scrollTo({ top: 0, left: 0 });
    };

    resetScrollPosition();
    const rafId = window.requestAnimationFrame(resetScrollPosition);
    return () => window.cancelAnimationFrame(rafId);
  }, [location.pathname, location.search]);

  return (
    <div className="wizard-shell min-w-0 w-full max-w-full">
      <div className="wizard-centering min-w-0 w-full max-w-full">
        <div className="wizard-container min-w-0 w-full max-w-full">
          <main ref={mainRef} className="wizard-main" role="main">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
